import { IDropdownStyles, IPivotStyles } from '@fluentui/react';
import { BoxShadow, FontSizes, FontWeights, IH2OTheme, IPivotContainerStyles, Sizes } from '@h2oai/ui-kit';
import { CSSProperties } from 'react';

export const aiUnitHourlyTopStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '50px',
};

export const plotStyle = {
  width: '100%',
  height: '500px',
};

export const PageStyle = {
  overflowY: 'auto' as 'auto' | 'hidden' | 'scroll' | 'visible',
};

export const statBarStyle = {
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: '1rem',
  gap: '2rem',
  height: 'fit-content',
};

export const chartWrapperStyle = {
  margin: '0 auto',
  maxHeight: 'calc(100vh - 350px)',
  maxWidth: 'calc(100vw - 620px)',
};

export const monthSelectDropdownStyles: Partial<IDropdownStyles> = {
  root: {
    width: '200px',
  },
  dropdownItemsWrapper: {
    maxHeight: '500px',
  },
};

export const InfoTextStyle = (theme: IH2OTheme): CSSProperties => ({
  margin: '1rem 0 0 0',
  fontWeight: FontWeights.semiBold,
  fontSize: FontSizes.xsmall,
  color: theme.palette?.gray400,
});

export const MonthDropdownStyle = {
  display: 'flex',
  marginRight: '20px',
  marginLeft: '50%',
  width: 'auto',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

export const AiUnitHourlyStyles = (theme: IH2OTheme) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: '2rem',
  padding: Sizes.padding,
  marginBottom: '2rem',
  backgroundColor: theme.palette?.white,
  borderRadius: Sizes.borderRadius,
  boxShadow: BoxShadow,
  color: theme.palette?.gray300,
});

export const InfoLabel = (theme: IH2OTheme) => ({
  fontWeight: FontWeights.bold,
  color: theme.palette?.gray500,
});

export const InfoValue = (theme: IH2OTheme) => ({
  fontWeight: FontWeights.normal,
  color: theme.palette?.black,
  fontSize: FontSizes.small,
});

export const pivotContainerStyles: Partial<IPivotContainerStyles> = {
  root: {
    flexGrow: 1,
    height: `calc(100% - 142.5px)`,
    selectors: {
      '.ms-Pivot-wrapper': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
};

export const pivotStyles: Partial<IPivotStyles> = {
  itemContainer: {
    height: `calc(100% - 36px)`,
    overflowY: 'auto',
  },
};
